import Api from "../../config/ApiConfig";
import {
  ISpokePostReq,
  ISpokeSearchParams,
} from "./types";

const apiUrls = {
  spokeURL: "api/v1/spokes",
};

export const getParam = (param: string[] | undefined, paramType: string) => {
  let str: string = "";
  if (param && param?.length > 0) str = `&${paramType}=${param}`;
  return str;
};

export const postSpoke = (payload: ISpokePostReq) =>
  Api.post(apiUrls.spokeURL, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });

export const getSpokeDetails = (params: ISpokeSearchParams) =>
  Api.get(
    `${apiUrls.spokeURL}?` +
    getParam(params.name, "name") +
    getParam(params.owner, "owner")
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });


export const getSpokeListDetails = (params: ISpokeSearchParams) =>
  Api.get(`${apiUrls.spokeURL}?`).then((response) => { return response; }).catch((error) => { return error.response; });

export const getSpokeDetailsById = (param: string) =>
  Api.get(apiUrls.spokeURL + `/${param}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });

export const deleteSpoke = (param: number) =>
  Api.delete(apiUrls.spokeURL + `/${param}`)
    .then((response) => { return response })
    .catch((error) => { return error.response });